const AppFooter = () => {
  return <footer className="mt-auto"></footer>;
};

export default AppFooter;
